import React from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap'

const ServiceDoctorInfo = ({ name, specialty, education, blurb, image, profileLink }) => {
  return (
    <div className='doc_about pt-3'>
      <Container fluid className='p-0'>
        <Row>
          <Col md={4}>
            <div className='doc_img'>
              <img src={image} alt={`${name} - ${specialty}`} />
            </div>
          </Col>
          <Col md={8}>
            <div className='doc_details'>
              <div className='doc_name'>
                <h3>{name}</h3>
                <h4 style={{ fontSize: '16px', color: '#875305' }}>{specialty}</h4>
              </div>
              {education && (
                <div className='doc_edu pt-2'>
                  <p style={{ fontSize: '14px' }}>{education}</p>
                </div>
              )}
              <div className='doc_content pt-2'>
                <p>{blurb}</p>
              </div>
              <div className='doc_btn pt-3'>
                <a href={profileLink}>
                  <Button size='sm'>View Profile &amp; Book</Button>
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default ServiceDoctorInfo
